import { createAction } from 'redux-actions';

export const loadEvents = createAction('EVENTS_LOAD');
export const loadEventsSuccess = createAction('EVENTS_LOAD_SUCCESS');
export const loadEventsFailure = createAction('EVENTS_LOAD_FAIL');

export const loadEventDetails = createAction('EVENT_DETAILS_LOAD');
export const loadEventDetailsSuccess = createAction('EVENT_DETAILS_LOAD_SUCCESS');
export const loadEventDetailsFailure = createAction('EVENT_DETAILS_LOAD_FAIL');